import React from 'react'

const Footer = () => (
  <div id="footer">
    <div className="inner">
      <ul className="icons">
        <li>
          <a href="https://www.linkedin.com/in/emanuele-d-94b058b0/" className="icon fa-linkedin">
            <span className="label">Twitter</span>
          </a>
        </li>
        <li>
          <a href="https://github.com/emanueleDiVizio" className="icon fa-github">
            <span className="label">Github</span>
          </a>
        </li>
        <li>
          <a href="https://medium.com/@accounts_32070" className="icon fa-medium">
            <span className="label">Dribbble</span>
          </a>
        </li>
        <li>
          <a href="mailto:info@emadivizio.com" className="icon fa-envelope-o">
            <span className="label">Email</span>
          </a>
        </li>
      </ul>
      <ul className="copyright">
        <li>&copy; Emanuele di Vizio 2020</li>
      </ul>
    </div>
  </div>
)

export default Footer
